import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { FinderModal } from 'libs/editor/views/finder';
import { modalStore } from 'apps/modals/app';
import { clientStore } from 'apps/client/app';

import { MediaMenuStyleOld, HiddenInput, MenuButton } from 'libs/editor/styles';

import { Icon } from 'components';

import { MediaMenuStyled } from './mediaMenu.styled';
import UploadButton from './uploadButton';

// FIXME - review this file + check if ref is necessary (we are over using refs)
/* eslint no-return-assign: 1 */

@observer
export class MediaMenu extends React.Component {
  uploadFile = e => {
    const {
      store: { UploadFile },
    } = this.props;
    UploadFile(e.target.files[0]);
    this.fileInput.value = '';
  };

  clickUpload = () => {
    this.fileInput.click();
  };

  clickFinder = () => {
    const { store } = this.props;
    const { mediaMenuStore } = store;
    modalStore.SetModalComponent(FinderModal, {
      size: 'large',
      editorStore: store,
      toFront: true,
    });
    mediaMenuStore.SetSelected(false);
  };

  toggleSelected = () => {
    if (this.onEmptyParagraph) {
      const {
        store: { mediaMenuStore, reference, onChange },
      } = this.props;
      mediaMenuStore.SetSelected(!mediaMenuStore.selected);
      if (!mediaMenuStore.selected) {
        const focusChange = reference.focus();
        onChange(focusChange);
      }
    }
  };

  addTable = () => {
    const {
      store: { InsertTable },
    } = this.props;

    InsertTable();
  };

  get onEmptyParagraph() {
    const {
      store: { value },
    } = this.props;
    const type = value && value.anchorBlock ? value.anchorBlock.type : null;
    return (
      type === 'paragraph' &&
      !value.blocks.some(block => {
        const inlines = !!block.getInlines().size;
        const blocks = !!block.getBlocks().size;
        const text = !!block.text;
        return inlines || blocks || text;
      })
    );
  }

  get visible() {
    const {
      store: { value, mediaMenuStore },
    } = this.props;
    const { selected } = mediaMenuStore;

    return (
      ((value.selection.isFocused || selected) && this.onEmptyParagraph) ||
      this.props.store.mediaMenuAlwaysVisible
    );
  }

  render() {
    const { store, style } = this.props;

    const { value, mediaMenuStore, selection, embedDisabled } = store;
    let { component } = store;

    if (mediaMenuStore.component) {
      // eslint-disable-next-line prefer-destructuring
      component = mediaMenuStore.component;
    }
    if (!component || !value) return null;
    const { selected, buttons } = mediaMenuStore;

    const opacity = this.visible ? 1 : 0;
    let buttonOpacity = selected ? 1 : 0;
    let left = -44;
    const topMinSize = 5.5;
    const topMin = output => (output > topMinSize ? output : topMinSize);
    let top = selection
      ? topMin(
          selection.top -
            component.getBoundingClientRect().top +
            component.offsetTop / 2 +
            1,
        )
      : topMinSize;

    let bottom = 'auto';
    if (store.mediaMenuAlwaysVisible) {
      // const inputRect = component.parentElement.getBoundingClientRect();
      // CAUTION: For the moment, we are only using this toolbar always visible thingy for chats
      //          Other components will have different structure
      // CAUTION: The following line assumes that the chat component has the following structure:
      /*
        0-> Chat header
        1-> Messages history
        2-> Chat input 
        [More children could appear later, but those are not important]
      */
      // Override position

      left = 0;
      bottom = '0px';
      top = 'auto';
      buttonOpacity = 1;
    }

    let buttonsElement = (
      <>
        <MenuButton
          size='small'
          rotated={selected}
          onClick={this.toggleSelected}
          variant={selected ? 'minimal' : 'secondary'}
          icon='add'
          style={{
            opacity: store.mediaMenuAlwaysVisible ? 0 : 1,
            pointerEvents: store.mediaMenuAlwaysVisible ? 'none' : '',
          }}
        />
        {Array.isArray(buttons) && buttonOpacity > 0 && (
          <>
            {buttons.map((button, i) => {
              if (button.type === 'upload') {
                return (
                  <React.Fragment key={i}>
                    <MenuButton
                      size='small'
                      opacity={buttonOpacity}
                      onClick={this.clickUpload}
                      icon={button.icon}
                      outline
                    />
                    <HiddenInput
                      id='fileInput'
                      ref={ref => {
                        this.fileInput = ref;
                      }}
                      type='file'
                      multiple={false}
                      onChange={this.uploadFile}
                    />
                  </React.Fragment>
                );
              }

              if (button.type === 'reference') {
                return embedDisabled ? null : (
                  <MenuButton
                    size='small'
                    key={i}
                    onClick={this.clickFinder}
                    icon={button.icon}
                    outline
                  />
                );
              }
              // TODO: Uncomment this "add table button"
              /* if (button.type === 'table') {
                return (
                  <MenuButton
                    size='small'
                    icon={button.icon}
                    onClick={this.addTable}
                    key={i}
                    outline
                  />
                );
              } */

              return null;
            })}
          </>
        )}
      </>
    );

    let MenuElement = MediaMenuStyleOld;

    if (store.mediaMenuAlwaysVisible) {
      buttonsElement = (
        <>
          <UploadButton
            onClick={this.clickUpload}
            size={clientStore.isMobile ? 'medium' : 'default'}
            disabled={!store.associatedSpaceId()}
          >
            <Icon name='add' size={clientStore.isMobile ? 'small' : 'xsmall'} />
          </UploadButton>
          <HiddenInput
            id='fileInput'
            ref={ref => {
              this.fileInput = ref;
            }}
            type='file'
            multiple={false}
            onChange={this.uploadFile}
          />
        </>
      );

      MenuElement = MediaMenuStyled;
    }

    // TODO: Check the + button once we have the final UI details
    return ReactDOM.createPortal(
      <MenuElement
        ref={mediaMenu => (mediaMenuStore.ref = mediaMenu)}
        opacity={opacity}
        top={top}
        left={left}
        bottom={bottom}
        style={style}
      >
        {buttonsElement}
        {/* TODO: alex - store.mediaMenuAlwaysVisible ? 'chat' : 'editor' */}
      </MenuElement>,
      component,
    );
  }
}

MediaMenu.propTypes = {
  style: PropTypes.object,
  store: PropTypes.object,
};
